module.exports = __webpack_public_path__ + "static/the-lancashire-hotpots-hotpotmania-tour-2026-7c1feee6e01e636a4afa4a8062aeefdc.jpg";